import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48b1afca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "type-row-wrapper" }
const _hoisted_2 = { class: "type-messages" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "detail" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "회원가입", -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString($props.useRankName), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_4, _toDisplayString($props.useRankName) + " 회원가입을 원하시면 선택해 주세요", 1 /* TEXT */)
    ]),
    _createElementVNode("div", { class: "signup-btn-wrapper" }, [
      _createElementVNode("button", {
        class: "signup-btn",
        onClick: $setup.onClickSignUp
      }, [..._hoisted_6])
    ])
  ]))
}